import { SettingsManager } from "@viamap/viamap2-common";
import { ESInterfaceBase } from "./ESInterfaceBase.ts";

export type { UTMGridData, UTMGridItem } from "./ESInterfaceBase.ts";

/**
 * Interface to Elastic Search
 */

export class ESInterface extends ESInterfaceBase {
   private elasticSearchUrl: string;
   private elasticSearchApiKey: string;

   constructor(index: string) {
      super(index);
      this.elasticSearchUrl = SettingsManager.getSystemSetting("elasticSearchUrl");
      this.elasticSearchApiKey = SettingsManager.getSystemSetting("elasticSearchApiKey");
   }

   protected async executeQuery(urlCommand: string, query: any): Promise<any> {
      let url = this.elasticSearchUrl;
      url += "/" + urlCommand;
      const response = await fetch(url, {
         method: "POST",
         headers: {
            Authorization: "ApiKey " + this.elasticSearchApiKey,
            "content-type": "application/json"
         },
         body: JSON.stringify(query)
      });
      if (response.status != 200) {
         throw new Error(response.statusText);
      }
      return response.json();
   }

   async indexExists(indexName: string): Promise<boolean> {
      const url = this.elasticSearchUrl + "/" + indexName;
      try {
         const response = await fetch(url, {
            method: "HEAD",
            headers: {
               Authorization: "ApiKey " + this.elasticSearchApiKey,
            }
         });
         return response.status === 200;
      } catch {
         return false;
      }
   }

   async runCommand(method: string, urlCommand: string, body: any, noJSON = false): Promise<any> {
      let url = this.elasticSearchUrl;
      url += "/" + urlCommand;

      if (!noJSON) {
         if (body === undefined || body === null) {
            body = (method === "PUT" || method === "POST") ? "{}" : undefined;
         } else {
            try {
               body = JSON.stringify(body);
            } catch (err: any) {
               throw new Error(`Elasticsearch: failed to serialize request body - ${err?.message || err}`);
            }
         }
      }

      return fetch(url, {
         method: method,
         headers: {
            Authorization: "ApiKey " + this.elasticSearchApiKey,
            "content-type": "application/json"
         },
         body: body

      })
         .then(async (response) => {
            let result = await response.json();
            if (result.error) {
               throw new Error(result.error.reason);
            }
            return result;
         });
   }
}